// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as DemoApi from "../bindings/DemoApi.bs.js";
import * as OAuthPkce from "../bindings/OAuthPkce.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";

let context = React.createContext({
  state: "LoggedOut",
  login: async () => {},
  logout: () => {},
  handleCallback: async param => {}
});

let make = context.Provider;

let ContextProvider = {
  make: make
};

let setWindowLocation = (function(url) { window.location.href = url });

let parseCallbackParams = (function(search) {
    var url = new URL("http://localhost" + search);
    return { code: url.searchParams.get("code"), state: url.searchParams.get("state") };
  });

let getStoredState = (function() { return sessionStorage.getItem("pkce_state"); });

function AuthContext$Provider(props) {
  let match = React.useState(() => "LoggedOut");
  let setState = match[1];
  let login = async () => setWindowLocation(await OAuthPkce.startAuth(DemoApi.oauthConfig()));
  let logout = () => {
    setState(param => "LoggedOut");
    RescriptReactRouter.push("/login");
  };
  let handleCallback = async search => {
    let params = parseCallbackParams(search);
    let code = params.code;
    let returnedState = params.state;
    let storedState = getStoredState();
    if (!(code == null)) {
      if (returnedState == null) {
        return;
      }
      if (!(storedState == null) && returnedState === storedState) {
        let config = DemoApi.oauthConfig();
        let tokenSet = await OAuthPkce.exchangeCode(config, code);
        let user = await OAuthPkce.fetchUserInfo(config, tokenSet.accessToken);
        return setState(param => ({
          TAG: "LoggedIn",
          _0: user
        }));
      }
    }
    if (!(returnedState == null)) {
      console.error("OAuth callback state mismatch — possible CSRF attack. Aborting.");
      return;
    }
  };
  let value_state = match[0];
  let value = {
    state: value_state,
    login: login,
    logout: logout,
    handleCallback: handleCallback
  };
  return JsxRuntime.jsx(make, {
    value: value,
    children: props.children
  });
}

let Provider = {
  make: AuthContext$Provider
};

function useAuth() {
  return React.useContext(context);
}

export {
  context,
  ContextProvider,
  setWindowLocation,
  parseCallbackParams,
  getStoredState,
  Provider,
  useAuth,
}
/* context Not a pure module */
